import { Injectable } from '@angular/core';
import { APP_CONFIG, Env, Region } from '../../environment';
import { LoggerProvider, LoggerEvent } from '../logger/logger';
import { HttpProvider } from '../http/http';

declare var document: any;
declare var ioGetBlackbox;
declare let Cardinal;

@Injectable()
export class ScriptProvider {
  private loadedScripts = [];
  private loadedCSS = [];
  private iovationPromise = null;
  private cardinalPromise = null;
  private adyenPromise = null;
  private cardinalUsed: boolean = false;
  private visaDirectPromise = null;
  private swiperPromise = null;
  private worldpayPromise = null;

  constructor() { }

  loadCardinal(forceNewUrls = false) {
    if (this.cardinalUsed) {
      LoggerProvider.info(this, 'Cardinal already in use, reload script');
      this.cardinalPromise = null;
      this.cardinalUsed = false;
    }
    if (!this.cardinalPromise) {
      // TODO !!!!!!!!!!!!!!!!!!!!! temporary
      if (forceNewUrls) {
        LoggerProvider.info(this, 'Loading Cardinal with new URLs');
        this.cardinalPromise = this.loadScript(APP_CONFIG.cardinalScriptV2, true);
      } else {
        this.cardinalPromise = this.loadScript(APP_CONFIG.cardinalScript, true);
      }
    }
    return this.cardinalPromise;
  }  

  initCardinal(jwt) {
    this.cardinalUsed = true;
    Cardinal.setup('init', {
      jwt: jwt
    });
  }

  loadIovation() {
    if (!this.iovationPromise)
      this.iovationPromise = this.loadScript(APP_CONFIG.iovationScript);
    return this.iovationPromise;
  }

  async getIovationBlackbox() {
    LoggerProvider.debug(this, 'Get Iovation blackbox');    

    try {
      await this.loadIovation();
      
      if (typeof ioGetBlackbox !== 'undefined' && ioGetBlackbox) {
        const blackbox = ioGetBlackbox().blackbox;
        LoggerProvider.debug(this, 'Succesfully got Iovation blackbox', blackbox);
        return blackbox;
      }
      else
        LoggerProvider.warning(this, LoggerEvent.ProviderException, 'Iovation not available');
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Unable to get Iovation blackbox');
    }
    return null;      
  }

  loadScript(source: string, force: boolean = false, integrity = '') {
    LoggerProvider.info(this, 'Check load script: ' + source + ' (force reload: ' + force + ')');
    return new Promise((resolve) => {
      //resolve if already loaded
      if (!force && this.loadedScripts.indexOf(source) > -1) {
        LoggerProvider.info(this, 'Script is already loaded: ' + source);
        resolve({ script: source, loaded: true, status: 'Already Loaded' });
      }
      else {
        if (force && this.loadedScripts.indexOf(source) > -1) {
          LoggerProvider.info(this, 'Script is already loaded: ' + source + ' - reload forced');
          const scripts = document.getElementsByTagName('script');
          for (let i=0; i < scripts.length; i++) {
            const script = scripts[i];
            if (script.src === source) {
              LoggerProvider.info(this, 'Already loaded script has been removed: ' + source);
              script.parentNode.removeChild(script);
              break;
            }
          }
        }
        
        //load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = source;
        if (integrity) {
          script.integrity = integrity;
          script.crossOrigin = 'anonymous';
        }

        LoggerProvider.info(this, 'Load script: ' + source);

        script.onload = () => {
          if (this.loadedScripts.indexOf(source) > -1)
            this.loadedScripts.push(source);
          LoggerProvider.info(this, 'Successfully Loaded script: ' + source);
          resolve({ script: source, scriptRef: script, loaded: true, status: 'Loaded' });
        };

        script.onerror = (ex) => {
          LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to load script: ' + source);
          resolve({ script: source, loaded: false, status: 'Failed to load' })
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }

  loadCSS(source: string, force: boolean = false, integrity = '') {
    LoggerProvider.info(this, 'Check load CSS: ' + source + ' (force reload: ' + force + ')');
    return new Promise((resolve) => {
      //resolve if already loaded
      if (!force && this.loadedCSS.indexOf(source) > -1) {
        LoggerProvider.info(this, 'CSS is already loaded: ' + source);
        resolve({ script: source, loaded: true, status: 'Already Loaded' });
      }
      else {
        if (force && this.loadedCSS.indexOf(source) > -1) {
          LoggerProvider.info(this, 'CSS is already loaded: ' + source + ' - reload forced');
          const scripts = document.getElementsByTagName('script');
          for (let i=0; i < scripts.length; i++) {
            const script = scripts[i];
            if (script.src === source) {
              LoggerProvider.info(this, 'Already loaded CSS has been removed: ' + source);
              script.parentNode.removeChild(script);
              break;
            }
          }
        }
        
        //load link
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = source;
        if (integrity) {
          link.integrity = integrity;
          link.crossOrigin = 'anonymous';
        }

        LoggerProvider.info(this, 'Load CSS: ' + source);

        link.onload = () => {
          if (this.loadedCSS.indexOf(source) > -1)
            this.loadedCSS.push(source);
          LoggerProvider.info(this, 'Successfully Loaded CSS: ' + source);
          resolve({ link: source, linkRef: link, loaded: true, status: 'Loaded' });
        };

        link.onerror = (ex) => {
          LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to load CSS: ' + source);
          resolve({ link: source, loaded: false, status: 'Failed to load' })
        };
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    });
  }

  loadRiskifiedBeacon() {
    (function() {
      function riskifiedBeaconLoad() {
        var store_domain = 'localhost';
        var session_id = encodeURIComponent(LoggerProvider.globalSessionId);
        var url = ('https:' == document.location.protocol ? 'https://' : 'http://')
          + "beacon.riskified.com?shop=" + store_domain + "&sid=" + session_id;
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = url;
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }
      /*
      if (window.attachEvent)
        window.attachEvent('onload', riskifiedBeaconLoad)
      else
        window.addEventListener('load', riskifiedBeaconLoad, false);
      */
      riskifiedBeaconLoad();
    })();
  }

  loadAdyen(useRegionalEndpoints = false) {
    if (this.adyenPromise)
      return this.adyenPromise;
    const adyenRegion = APP_CONFIG.region.adyenRegion && useRegionalEndpoints ? APP_CONFIG.region.adyenRegion : 'live'

    const src = 'https://checkoutshopper-' + adyenRegion + '.adyen.com/checkoutshopper/sdk/6.41.1/adyen.js';
    const srcIntegrity = 'sha384-DB9arkhXw13VpZMoNgcKmtQUh5V38dAcOMnKkE3jmjl9Nf7ObyB1h1KeTLftdvUo';

    const css = 'https://checkoutshopper-' + adyenRegion + '.adyen.com/checkoutshopper/sdk/6.41.1/adyen.css';
    const cssIntegrity = 'sha384-QCE3u3lliHH3SEx30M8NEuDhvEGmFCtZl62YVSVWw84cYNt2NYYbVwd/KPaaaIQ9';

    const srcFallback = 'assets/js/adyen641.js';
    const cssFallback = 'assets/css/adyen641.css';



    LoggerProvider.info(this, `Loading Adyen script (regional endpoints: ${useRegionalEndpoints}, region: ${adyenRegion})`);
    this.adyenPromise = new Promise(async (resolve) => {
      let scriptLoaded = false;
      let cssLoaded = false;
      let tries = 0;
      let usingFallback = false;
      const maxTriesBeforeFallback = 1;

      // Current URLs being used
      let currentSrc = src;
      let currentCss = css;

      while (true) {
        // Switch to fallback URLs after max primary attempts
        if (!usingFallback && tries >= maxTriesBeforeFallback) {
          LoggerProvider.info(this, 'Switching to fallback Adyen assets after ' + tries + ' attempts');
          usingFallback = true;
          currentSrc = srcFallback;
          currentCss = cssFallback;
        }

        let scriptPromise = null;
        let cssPromise = null;
        if (!scriptLoaded)
          scriptPromise = this.loadScript(currentSrc, false, srcIntegrity);
        if (!cssLoaded)
          cssPromise = this.loadCSS(currentCss, false, cssIntegrity);

        if (scriptPromise) {
          try {
            const result = await scriptPromise;
            if (result && result.loaded) {
              LoggerProvider.info(this, 'Successfully loaded Adyen script' + (usingFallback ? ' (fallback)' : ''));
              scriptLoaded = true;
            } else
              LoggerProvider.warning(this, LoggerEvent.ProviderException, 'Failed to load Adyen script' + (usingFallback ? ' (fallback)' : ''), result);
          } catch (ex) {
            LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to load Adyen script' + (usingFallback ? ' (fallback)' : ''));
          }
        }

        if (cssPromise) {
          try {
            const result = await cssPromise;
            if (result && result.loaded) {
              LoggerProvider.info(this, 'Successfully loaded Adyen CSS' + (usingFallback ? ' (fallback)' : ''));
              cssLoaded = true;
            } else
              LoggerProvider.warning(this, LoggerEvent.ProviderException, 'Failed to load Adyen CSS' + (usingFallback ? ' (fallback)' : ''), result);
          } catch (ex) {
            LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to load Adyen CSS' + (usingFallback ? ' (fallback)' : ''));
          }
        }

        if (scriptLoaded && cssLoaded)
          break;

        tries++;
        LoggerProvider.info(this, 'Retry loading Adyen (try ' + tries + ')' + (usingFallback ? ' using fallback assets' : ''));
      }

      resolve(true);
    });

    return this.adyenPromise;
  }

  loadVisaDirect() {
    if (!this.visaDirectPromise)
      this.visaDirectPromise = this.loadScript(APP_CONFIG.visaDirectScript);
    return this.visaDirectPromise;
  }

  loadWorldPay() {
    if (this.worldpayPromise)
      return this.worldpayPromise;

    // Worldpay serves the Checkout SDK from a sandbox host in non-prod and the live host in prod.
    const host = APP_CONFIG.env === Env.PROD ? 'access.worldpay.com' : 'try.access.worldpay.com';
    const src = 'https://' + host + '/access-checkout/v2/checkout.js';

    LoggerProvider.info(this, 'Loading Worldpay script');
    this.worldpayPromise = this.loadScript(src);
    return this.worldpayPromise;
  }

}



// WEBPACK FOOTER //
// ./src/providers/script/script.ts